/**
 * product.restock テンプレ専用: バリアント切替時に ATC ↔ 再入荷を切替。
 * theme.js の ATC 更新の後に走らせる（capture: false）。
 */
(function () {
  function root() {
    return document.querySelector('[data-restock-pdp]');
  }

  function parseVariants(wrap) {
    var el = wrap.querySelector('[data-restock-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function findVariant(list, id) {
    var want = String(id || '');
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === want) return list[i];
    }
    return null;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    return '¥' + Math.round(Number(cents) / 100).toLocaleString('ja-JP');
  }

  function applyUi(wrap, variant) {
    if (!wrap || !variant) return;

    var hasTag = wrap.getAttribute('data-restock-tag') === 'true';
    var threshold = parseInt(wrap.getAttribute('data-inv-threshold') || '0', 10);
    var usePrimary = wrap.getAttribute('data-use-primary-button') === 'true';
    var showPrice = wrap.getAttribute('data-show-price') === 'true';
    var atcLabel = wrap.getAttribute('data-atc-label') || '';
    var soldOutLabel = wrap.getAttribute('data-sold-out-label') || 'Sold out';

    var atc = wrap.querySelector('[data-restock-atc]');
    var restockWrap = wrap.querySelector('[data-restock-wrap]');
    var payment = wrap.querySelector('[data-restock-payment]');

    if (variant.control_sales || variant.coming_soon) {
      if (restockWrap) restockWrap.hidden = true;
      if (atc) atc.hidden = false;
      if (payment) payment.style.display = 'none';
      return;
    }

    var inStock = parseInt(variant.inventory_quantity, 10) > threshold;
    var showRestock = hasTag && !inStock;

    if (atc) {
      atc.classList.remove('Button--primary', 'Button--secondary');
      if (showRestock) {
        atc.hidden = true;
      } else {
        atc.hidden = false;
        if (inStock) {
          atc.removeAttribute('disabled');
          atc.setAttribute('data-action', 'add-to-cart');
          atc.classList.add(usePrimary ? 'Button--primary' : 'Button--secondary');
          var html = '<span>' + atcLabel + '</span>';
          if (showPrice) {
            html +=
              '<span class="Button__SeparatorDot"></span><span data-money-convertible>' +
              formatMoney(variant.price) +
              '</span>';
          }
          atc.innerHTML = html;
        } else {
          atc.setAttribute('disabled', 'disabled');
          atc.removeAttribute('data-action');
          atc.classList.add('Button--secondary');
          atc.innerHTML = '<span>' + soldOutLabel + '</span>';
        }
      }
    }

    if (restockWrap) {
      restockWrap.hidden = !showRestock;
    }

    if (payment) {
      payment.style.display = inStock && !showRestock ? '' : 'none';
    }
  }

  function onVariantChanged(ev) {
    var wrap = root();
    if (!wrap) return;
    var variant = ev.detail && ev.detail.variant;
    if (!variant || !variant.id) return;
    var meta = findVariant(parseVariants(wrap), variant.id);
    if (!meta) {
      meta = {
        id: variant.id,
        inventory_quantity: variant.inventory_quantity,
        price: variant.price,
        control_sales: false,
        coming_soon: false
      };
    }
    // theme.js が ATC を書き換えた後に上書き
    window.setTimeout(function () {
      applyUi(wrap, meta);
    }, 0);
  }

  document.addEventListener('variant:changed', onVariantChanged);
})();
